import appConstants from "../../../../../appConstants";
const [Planning, Dispatch] = appConstants.MODULES;
import kpiChartConfig from "../ChartConfig";
import { format } from "date-fns";

const prepareBillData = (chartData) => {
  return [
    {
      name: Planning,
      totalBill: chartData?.planningData["totalBills"] ?? [],
      deliveryBills: chartData?.planningData["deliveryBills"] ?? [],
    },
    {
      name: Dispatch,
      totalBill: chartData?.dispatchData["totalBills"] ?? [],
      deliveryBills: chartData?.dispatchData["deliveryBills"] ?? [],
    },
  ];
};

const renderColorfulLegendText = (value, entry) => {
  const { color } = entry;
  return <span style={{ color }}>{value}</span>;
};

const getModuleList = () => {
  return appConstants.MODULES.map((name, index) => ({
    value: index,
    name: name,
    isChecked: index === 0 ? true : false,
  }));
};

/* 
  @function :- renameKeyAndMergeObject
  @Description:- merge Planning & Dispatch kpiData in single array of object as well as renaming fieldName
    by appending module name.
  @groupBy:- if groupBy="planDate" then for both module will create a single object, xaxis data key will be planDate
  input:- { data: [{
    "name": "Planning",
    "data": [{
        "scenarioId": 5222,
        "planDate": "01-17-2022",
        "terminalId": 6,
        "kpiName": "Routes",
        "value": 27,
        "goal": 0
      }],
      "isChecked": true
    },
    {
      "name": "Dispatch",
      "data": [{
        "planDate": "01-17-2022",
        "kpiName": "Routes",
        "value": 2,
        "goal": 0
        }],
      "isChecked": false
    }
  ]}
  output: [{
    "Planning_scenarioId": 5222,
    "planDate": "01-17-2022",
    "Planning_terminalId": 6,
    "Planning_kpiName": "Routes",
    "Dispatch_kpiName": "Routes",
    "Dispatch_value": 2,
    "Planning_value": 27,
    "goal": 0
  }]
*/
const renameKeyAndMergeObject = ({ data = {}, groupBy = undefined, keyListWillNotRenamed=[] }) => {
  let result = [], xAxisKey = groupBy;
  result = Object.keys(data).reduce(
    (function (hash) {
      return function (modifiedData, index) {
        data[index].data.forEach(function (eachObj) {
          if (!xAxisKey)
            xAxisKey = eachObj.hasOwnProperty("name") ? "name" : "routeName";
          if (!hash[eachObj[xAxisKey]]) {
            hash[eachObj[xAxisKey]] = {};
            modifiedData.push(hash[eachObj[xAxisKey]]);
          }
          Object.keys(eachObj).forEach(function (eachKey) {
            if (keyListWillNotRenamed.includes(eachKey)) {
              /* Field will not be renamed, if field exist then value will be picked */
              hash[eachObj[xAxisKey]][eachKey] = eachObj[eachKey]
              return
            }
            hash[eachObj[xAxisKey]][eachKey] = eachObj[eachKey];
            if (eachKey !== xAxisKey) {
              hash[eachObj[xAxisKey]][`${data[index].name}_${eachKey}`] =
                eachObj[eachKey];
              delete hash[eachObj[xAxisKey]][eachKey];
            }
          });
        });
        return modifiedData;
      };
    })(Object.create(null)),
    []
  );
  return result;
};

const getModifiedKPIName = (label, moduleName) => {
  return `${label} (${moduleName})`
}

const getModuleChartData = (data, moduleName) => {
  return data.find(el => el.name === moduleName)?.data ?? []
}

const CustomLabelList = props => {
  const { x, y, width, value, chartConfig } = props;
  if (chartConfig.chartType === "bar") {
    return (y ? 
      (<g>
        <text
          x={x + width / 2}
          y={y - 10}
          style={{ fontSize: "10px" }}
          fill={kpiChartConfig.chartColors.customLabel}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {value}
        </text>
      </g>) : ""
    ); 
  } else if (chartConfig.chartType === "stackedBar") {
      return (y ?
        (<g>
          <text
            x={x + width / 2}
            y={y - 10}
            style={{ fontSize: "10px" }}
            fill={kpiChartConfig.chartColors.customLabel}
            textAnchor="middle"
            dominantBaseline="middle"
          >
            {value}
          </text>
        </g>) : ""
      );
    }
}

const getFormattedPlanDate = (value) => {
  return format(new Date(value), appConstants.DATETYPES.DATETIME.updateFormat).slice(0, 10)
}

const formatValue = (value, name, props) => {
  const indexOfSymbol = name.indexOf(" (")
  if (indexOfSymbol!=-1) {
    name = name.substring(0, indexOfSymbol)
  }
  const newValue = parseFloat(value).toFixed(2)
  if (["Stops Per Hour", "Miles Per Stop","Stem Miles","On Area Miles"].includes(name)) {
    return newValue;
  } else if (name === "Stop Time") {
    return `${newValue} hr`;
  } else if (name === "Windshield Hours") {
    return `${newValue} hr`;
  } else if (name === "Empty Time") {
    const moduleName = props?.dataKey.split('_')[0]
    const kpiName = `${moduleName}_routeName` 
    const routeName = props.payload[kpiName]
    if (props.payload[kpiName]) {
      return `${newValue}% , Route Name : ${routeName}`; 
    }
    return `${newValue}%`;
  }
  return parseFloat(value);
};

export { 
  prepareBillData, 
  getModuleList, 
  renameKeyAndMergeObject, 
  getModifiedKPIName,
  getModuleChartData,
  renderColorfulLegendText,
  CustomLabelList,
  formatValue,
  getFormattedPlanDate,
};
